import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LoadingIndicator from '../LoadingIndicator';
import styles from './styles.scss';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

const defaultProps = {
  children: undefined,
};

const NavigationTreeNodeLoading = ({ children }) => {
  const classes = cx(
    styles.loadingIndicator,
    children && styles.withChildren,
  );

  return (
    <li className={classes}>
      <LoadingIndicator className={styles.loadingIndicatorContent} />
      {children && (
        <ul className={styles.loadingIndicatorTree}>
          {children}
        </ul>
      )}
    </li>
  );
};

NavigationTreeNodeLoading.propTypes = propTypes;
NavigationTreeNodeLoading.defaultProps = defaultProps;

export default NavigationTreeNodeLoading;
